export default __webpack_public_path__ + "static/media/Placeholder_Icon.de35f684.svg";